// Продавец по договору поручения: клиент CRM или (у серых дилеров) сам ДЦ.
// Бэк отдаёт их в разных полях — consignment.seller и consignment.sellerDc.

export const consignmentSellerOf = (consignment) =>
  consignment?.seller || (consignment?.sellerDc ? { ...consignment.sellerDc, isDc: true } : null);

export const sellerOptionOf = (seller) => {
  if (!seller) return null;
  if (seller.isDc) {
    return { value: seller.id, label: `${seller.name || ''}${seller.bin ? ` (БИН: ${seller.bin})` : ''}`.trim() };
  }
  return {
    value: seller.id,
    label: `${seller.surname || ''} ${seller.name || ''}`.trim() + (seller.iin ? ` (ИИН: ${seller.iin})` : ''),
  };
};
